<rt-impact-tracker-insights [logoHeading]="data.logoHeading" [subheading]="data.subheading">
  <ng-container headingText>
    <div [innerHTML]="data?.heading" class="heading-text"></div>
  </ng-container>

  <ng-container insights>
    @for (card of data?.cards; track $index) {
      <rt-insights-card
        [iconName]="$any(card.icon)"
        [value]="card.value"
        [title]="card.title"
        [label]="card.label"
        [tooltip]="card.tooltip"
      />
    }
  </ng-container>
</rt-impact-tracker-insights>
